import { render, staticRenderFns } from "./changeNickName.vue?vue&type=template&id=7b51698c"
import script from "./changeNickName.vue?vue&type=script&lang=js"
export * from "./changeNickName.vue?vue&type=script&lang=js"
import style0 from "./changeNickName.vue?vue&type=style&index=0&id=7b51698c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b51698c')) {
      api.createRecord('7b51698c', component.options)
    } else {
      api.reload('7b51698c', component.options)
    }
    module.hot.accept("./changeNickName.vue?vue&type=template&id=7b51698c", function () {
      api.rerender('7b51698c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/changeNickName.vue"
export default component.exports